import http from '@/http';
const selectContratos = (filtro) => {
  var contratos = [];
  filtro.forEach((item) => {
    if (!contratos.some(el => el.numero == item.sq_contrato)) {
      contratos.push({ nome: item.contrato + " [" + item.sq_contrato + "]", numero: item.sq_contrato, matriz: item.cd_matriz });
    }
  });
  return contratos;
}

const selectProjetos = (filtro, condicao) => {
  var projetos = [];
  filtro.forEach((item) => {
    if (item.sq_contrato == condicao) {
      if (!projetos.some(el => el.numero == item.cd_projeto)) {
        projetos.push({
          nome: item.projeto + " [" + item.cd_projeto + "]",
          numero: item.cd_projeto
        });
      }
    }
  });
  return projetos;
}

const selectCooperados = (filtro, condicao) => {
  var cooperados = [];
  filtro.forEach((item) => {
    if (item.cd_projeto == condicao) {
      cooperados.push({
        nome: item.nm_cooperado + " [" + item.cd_cooperado + "]",
        numero: item.cd_cooperado
      });
    }
  });
  return cooperados;
}

const buscarJustificativas = (carteira, transacao, sequencia = 0) => {
  return new Promise((resolve) => {
    http.get('api/rdvTomador/buscarJustificativas/' + carteira + '/' + transacao + '/' + sequencia, {
    }).then((response) => {
      resolve(response.data);
    }).catch((err) => {
      console.log(err);
    })
  })
}

const buscarEmpresas = () => {
  return new Promise((resolve) => {
    http.get('api/auth/buscarEmpresas')
      .then((response) => {
        resolve(response.data);
      }).catch((err) => {
        console.log(err);
      })
  })
}

export {
  selectContratos,
  selectProjetos,
  selectCooperados,
  buscarJustificativas,
  buscarEmpresas
}